import { SVGInjector } from '@tanem/svg-injector'
SVGInjector(document.getElementsByClassName('tosvgpath'))

import MenuBar from './menu-bar/menu-bar';
// import { Animations } from './animations/animations';
import { MenuOverlay } from './menu-overlay/menu-overlay';
import { PageLoader } from './page-loader/loading';
import aos from 'aos';

require("@fancyapps/fancybox");

// Set jQuery
window.$ = window.jQuery;

window.$.fn.isInViewport = function (real = true) {
  var isView = false;
  
  var viewportTop = real ? $(window).scrollTop() : $(window).scrollTop() + 30;
  var viewportBottom = real ? viewportTop + $(window).height() : viewportTop;

  if ($(this).length === 0) return false;
  else if ($(this).length === 1) {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    isView = elementBottom > viewportTop && elementTop < viewportBottom;
  } else {
    $(this).each(function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      if (elementBottom > viewportTop && elementTop < viewportBottom) isView = true;
    });
  }
  return isView;
};

// Load PageLoader JS && document.ready
PageLoader().then(function () {

  //desktop-menu open
  $(".child-menu").on("mouseenter", function () {
    $(".top-menu").addClass("child-active");
  });
  $(".child-menu").on("mouseleave", function () {
    $(".top-menu").removeClass("child-active");
  });
  $(".menu-submenu").on("mouseenter", function () {
    $(".top-menu").addClass("child-active");
  });
  $(".menu-submenu").on("mouseleave", function () {
    $(".top-menu").removeClass("child-active");
  });
  // Load Animations
  // Animations();
  aos.init({
    // disable: 'mobile',
    once: true,
    offset: 300,
    duration: 600
  });

  $("[data-textchange]").each(function (i, el) {
    var arr = $(this).data("textchange").split(",");
    var idx = 0;
    setInterval(function () {
      var next = arr[idx + 1] ? arr[idx + 1] : arr[0];
      if ($(el).html().indexOf(arr[idx]) >= 0) {
          $(el).html($(el).text().replace(arr[idx], '<span style="display:inline-block" data-aos="fade-in" data-aos-duration="1500">' + next + '</span>'));
          if (arr[idx + 1]) idx++;
          else idx = 0;
      }
    }, 3000);
  });

  // animation number
  $("[data-number]").each(function (i, el) {
    $(this).text("0");
    setInterval(() => {
      var elem = $(this).offset();
      var shouldAnimate = (window.scrollY + window.innerHeight) >= elem.top;
      if (shouldAnimate && !$(this).hasClass("counter")) {
        $(this).addClass("counter");
        $(this).prop('counter', 0).animate({
          counter: $(this).data("number")
        }, {
          duration: 2000,
          easing: 'swing',
          // step: function (now) {
          //   $(this).text(Math.ceil(now));
          // }
          step: function (now, fx) {
            $(el).text(new Intl.NumberFormat(document.documentElement.lang).format(Math.ceil(now)) + (el.dataset.sym ? el.dataset.sym : ''));
          },
          complete: function () {
            $(el).text(new Intl.NumberFormat(document.documentElement.lang).format($(this).data("number")) + (el.dataset.sym ? el.dataset.sym : ''));
            // if (el.dataset.sym !== undefined) {
            //   el.textContent = el.textContent.concat(el.dataset.sym)
            // }
          }
        });
      }
    }, 1000);
  });

  (function () {
    var throttle = function (type, name, obj) {
      var obj = obj || window;
      var running = false;
      var func = function () {
        if (running) { return; }
        running = true;
        requestAnimationFrame(function () {
          obj.dispatchEvent(new CustomEvent(name));
          running = false;
        });
      };
      obj.addEventListener(type, func);
    };
    throttle("scroll", "optimizedScroll");
  })();
  window.addEventListener("optimizedScroll", function () {
    if ($(".zoom").length) {
      // image zoom transform matrix
      $(".zoom").each(function () {
        $(this).parent().css("overflow", "hidden");
        $(this).css("transform", "matrix(1.2, 0, 0, 1.2, 0, 0)");
        var offsetTop = $(this).position().top - window.innerHeight;
        var posRel = window.pageYOffset - offsetTop;
        if (posRel >= 0) {
          var matrix = 1.2 - (posRel / window.innerHeight / 10);
          if (matrix < 1) return;
          $(this).css("transform", "matrix(" + matrix + ", 0, 0, " + matrix + ", 0, 0)");
        }
      });
    }

    // to menu logo invert colors
    checkLogoTopSVG();

    $("iframe[data-src]").each(function () {
      // if ($(this).isInViewport(0) && !$(this).attr("src")) $(this).attr("src", $(this).data("src"));
      if (!mobileCheck() && !$(this).attr("src")) $(this).attr("src", $(this).data("src"));
    });

  });

  // to menu logo invert colors
  checkLogoTopSVG();

  // popup newsletter
  if ($(".kn-popup-1:not(.closed)").length && !sessionStorage.getItem('kn-popup-1')) {  // && window.pageYOffset > window.innerHeight * 2
    setTimeout(function () {
      $(".kn-popup-1").addClass("active");
      sessionStorage.setItem('kn-popup-1', 1);
    }, 30000);
  }

  // lazy load iframes
  setTimeout(() => {
    $("iframe[data-src]").each(function () {
      // if ($(this).isInViewport(0) && !$(this).attr("src")) $(this).attr("src", $(this).data("src"));
      if (!mobileCheck() && !$(this).attr("src")) $(this).attr("src", $(this).data("src"));
    });
  }, 300);

  // find us footer
  $("#footer .cities li").on("mouseenter click", function () {
    $("#footer .cities li").removeClass("active");
    $(this).addClass("active");
    var html = $(this).find("div").html();
    $("#footer .cities .desc").hide().html(html).fadeIn();
  });
  $("#footer .cities li:first-child").click();

  // sizes list
  $(".sizes-list input").on("change", function () {
    $(".sizes-list p").hide();
    if ($(this).is(":checked") && $(this).attr("id").replace("nivel1", "nivel2").length > 0) $("#" + $(this).attr("id").replace("nivel1", "nivel2")).show();
  });
  $(".sizes-list input").first().click();

  // fancybox vimeo
  $("a").each(function () {
    if ($(this).attr("href") && $(this).attr("href") == "https://vimeo.com/kenduinstore") return;
    if ($(this).attr("href") && $(this).attr("href").indexOf("vimeo.com") >= 0) $(this).fancybox();
    if ($(this).hasClass("fancybox")) $(this).fancybox();
    if ($(this).attr("href") && $(this).attr("href").indexOf(".pdf") >= 0) $(this).attr("target", "_blank");
  });

  // Menu
  MenuBar();

  // Menu Overlay
  MenuOverlay();

  // submit newsletter form
  $('#newsletter-popup,#newsletter-footer').submit(function () {
    var form = $(this);
    $.ajax({
      url: form.attr('action'),
      type: 'POST',
      data: form.serialize(),
      success: function (data) {
        // alert(data);
        form.hide();
        if ($("#" + form.attr('id') + "-thanks").length) $("#" + form.attr('id') + "-thanks").removeClass("hidden");
      }
    });
    return false;
  });

});

function checkLogoTopSVG() {
  $(".top-menu svg").each(function () {
    $(this).removeClass("black").removeClass("white").removeClass("gray");
    $(this).addClass("white");

    /*if ($("#menu-overlay.show").length) {
      $(this).addClass("black");
      return;
    }

    if (
      $(".page-template-page-fulltext").isInViewport(0) ||
      $(".wp-block-group").isInViewport(0) ||
      $(".wp-block-spacer").isInViewport(0) ||
      $(".wp-block-embed").isInViewport(0) ||
      ($(".kn-products").isInViewport(0) && !$(".kn-products .products").isInViewport(0)) ||
      $(".kn-featured-5").isInViewport(0) ||
      ($(".kn-featured-6").isInViewport(0) && !$(".kn-featured-6 img").isInViewport(0)) ||
      $(".kn-hero-4").isInViewport(0) ||
      $(".kn-content-section-1").isInViewport(0) ||
      $(".kn-content-section-2").isInViewport(0) ||
      $(".kn-content-section-3").isInViewport(0) ||
      $(".kn-content-section-5").isInViewport(0) ||
      $(".kn-content-section-7").isInViewport(0) ||
      $(".kn-content-section-10").isInViewport(0) ||
      $(".kn-content-section-11").isInViewport(0) ||
      $(".kn-content-section-12").isInViewport(0) ||
      $(".kn-content-section-14").isInViewport(0) ||
      $(".kn-content-section-15").isInViewport(0) ||
      ($(".kn-content-section-16").isInViewport(0) && !$(".kn-content-section-16 .items").isInViewport(0)) ||
      $(".kn-content-section-17").isInViewport(0) ||
      $(".kn-content-section-19").isInViewport(0) ||
      $(".kn-content-section-20").isInViewport(0) ||
      $(".kn-content-section-21").isInViewport(0) ||
      $(".kn-content-section-23").isInViewport(0) ||
      $(".kn-content-section-24").isInViewport(0) ||
      $(".kn-content-section-27").isInViewport(0) ||
      $(".kn-post-list-1").isInViewport(0) ||
      $(".wp-block-kn-kn-section").isInViewport(0) ||
      $(".wp-block-image").isInViewport(0) ||
      $(".wp-block-columns").isInViewport(0) ||
      $(".kn-form-1").isInViewport(0) ||
      $(".kn-form-2").isInViewport(0) ||
      $(".kn-form-3").isInViewport(0) ||
      $(".kn-form-4").isInViewport(0) ||
      $(".kn-form-5").isInViewport(0) ||
      $(".kn-post-list-2").isInViewport(0) ||
      $(".kn-post-list-3").isInViewport(0)||
      $(".archive").isInViewport(0)
    ) {
      $(this).addClass("black");
    } else $(this).addClass("white");*/


    if (
      $(".kn-post-list-1").isInViewport(0) ||
      $(".kn-post-list-2").isInViewport(0) ||
      $(".kn-form-2").isInViewport(0) 
    ) {
      $(this).removeClass("white");
      $(this).addClass("black");
    } else $(this).addClass("white");
  });
}

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

